import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchOrders,
  updateOrder,
  deleteOrder,
} from "../../features/order/orderSlice";
import SideAndSearchbar from "../../Components/layouts/SideAndSearchbar";
import EditOrderModal from "./EditOrderModel";

const OrdersTable = () => {
  const dispatch = useDispatch();
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [error, setError] = useState(null);

  const {
    data: ordersData,
    isLoading,
    isError,
  } = useSelector((state) => state.order);
  const searchQuery = useSelector((state) => state.search.query);

 

  useEffect(() => {
    if (window.feather) {
      window.feather.replace();
    }
    dispatch(fetchOrders({ page: 1, limit: 5 }));
  }, [dispatch]);

  const handleEdit = (order) => {
    setSelectedOrder(order);
    setShowModal(true);
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleUpdate = async (updatedOrder) => {
    try {
      await dispatch(
        updateOrder({
          orderId: updatedOrder._id,
          updatedOrderData: updatedOrder,
        })
      );
      handleCloseModal();
    } catch (error) {
      console.error("Error updating order:", error);
    }
  };

  const handleDelete = async (orderId) => {
    if (window.confirm("Are you sure you want to delete this order?")) {
      try {
        await dispatch(deleteOrder(orderId));
      } catch (error) {
        console.error("Error deleting order:", error);
      }
    }
  };

  console.log("ordersData: ", ordersData)
  // Ensure you're accessing the orders array correctly
  // const filteredOrders = ordersData.orders?.filter((order) =>
  //   order.products[0].product.title
  //     .toLowerCase()
  //     .includes(searchQuery.toLowerCase())
  // );

  // console.log("filterData:", filteredOrders)

  if (isError) {
    return (
      <div className="error-message">
        An error occurred while fetching orders.
      </div>
    );
  }

  return (
    <>
      <SideAndSearchbar />
      <div className="pcoded-main-container">
        <div className="col-xl-12 d-flex justify-content-center mt-5">
          <div className="card">
            <div className="card-header">
              <h5>Orders Table</h5>
              <span className="d-block m-t-5">
                For admin only <code>table-order</code> inside ECOMMERCE
              </span>
            </div>
            <div className="card-body table-border-style">
              <div className="table-responsive">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>S_no.</th>
                      <th>Order Id</th>
                      <th>Product Id</th>
                      <th>Price(₹)</th>
                      <th>Quantity</th>
                      <th>Order date</th>
                      <th>Status</th>
                      <th>Actions</th>
                      <th>Edit</th>
                      <th>Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    {isLoading ? (
                      <tr>
                        <td colSpan="10" className="text-center">
                          Loading...
                        </td>
                      </tr>
                    ) : ordersData?.length > 0 ? (
                      ordersData.map((order, index) => (
                        <tr key={order._id}>
                          <td>{index + 1}</td>
                          <td>{order._id}</td>
                          <td>{order.products[0]._id}</td>
                          <td>{order.grand_total}</td>
                          <td>{order.products[0].quantity}</td>
                          <td>{order.created_at}</td>
                          <td>{order.status}</td>
                          <td>
                            <button
                              className="btn btn-primary"
                              onClick={() => console.log("View order details")}
                            >
                              View
                            </button>
                          </td>
                          <td>
                            <i
                              className="feather icon-edit"
                              style={{ color: "blue", cursor: "pointer" }}
                              onClick={() => handleEdit(order)}
                            />
                          </td>
                          <td>
                            <i
                              className="feather icon-delete"
                              style={{ color: "red", cursor: "pointer" }}
                              onClick={() => handleDelete(order._id)}
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="10" className="text-center">
                          No orders available.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      {showModal && (
        <EditOrderModal
          order={selectedOrder}
          onUpdate={handleUpdate}
          onCancel={handleCloseModal}
        />
      )}
    </>
  );
};

export default OrdersTable;
